function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagestyle/imagestyleui
 */
import { Plugin } from 'ckeditor5/src/core';
import { ButtonView, createDropdown, addToolbarToDropdown, SplitButtonView } from 'ckeditor5/src/ui';
import ImageStyleEditing from './imagestyleediting';
import utils from './utils';
import { isObject, identity } from 'lodash-es';
import '../../theme/imagestyle.css';
/**
 * The image style UI plugin.
 *
 * It registers buttons corresponding to the {@link module:image/image~ImageConfig#styles} configuration.
 * It also registers the {@link module:image/imagestyle/utils~DEFAULT_DROPDOWN_DEFINITIONS default drop-downs} and the
 * custom drop-downs defined by the developer in the {@link module:image/image~ImageConfig#toolbar} configuration.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageStyleUI = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageStyleUI, _Plugin);

  var _super = _createSuper(ImageStyleUI);

  function ImageStyleUI() {
    _classCallCheck(this, ImageStyleUI);

    return _super.apply(this, arguments);
  }

  _createClass(ImageStyleUI, [{
    key: "localizedDefaultStylesTitles",
    get:
    /**
     * Returns the default localized style titles provided by the plugin.
     *
     * The following localized titles corresponding with
     * {@link module:image/imagestyle/utils~DEFAULT_OPTIONS} are available:
     *
     * * `'Wrap text'`,
     * * `'Break text'`,
     * * `'In line'`,
     * * `'Full size image'`,
     * * `'Side image'`,
     * * `'Left aligned image'`,
     * * `'Centered image'`,
     * * `'Right aligned image'`
     *
     * @returns {Object.<String,String>}
     */
    function get() {
      var t = this.editor.t;
      return {
        'Wrap text': t('Wrap text'),
        'Break text': t('Break text'),
        'In line': t('In line'),
        'Full size image': t('Full size image'),
        'Side image': t('Side image'),
        'Left aligned image': t('Left aligned image'),
        'Centered image': t('Centered image'),
        'Right aligned image': t('Right aligned image')
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "init",
    value: function init() {
      var plugins = this.editor.plugins;
      var toolbarConfig = this.editor.config.get('image.toolbar') || [];
      var definedStyles = translateStyles(plugins.get('ImageStyleEditing').normalizedStyles, this.localizedDefaultStylesTitles);

      var _iterator = _createForOfIteratorHelper(definedStyles),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var styleConfig = _step.value;

          this._createButton(styleConfig);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var definedDropdowns = translateStyles([].concat(_toConsumableArray(toolbarConfig.filter(isObject)), _toConsumableArray(utils.getDefaultDropdownDefinitions(plugins))), this.localizedDefaultStylesTitles);

      var _iterator2 = _createForOfIteratorHelper(definedDropdowns),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var dropdownConfig = _step2.value;

          this._createDropdown(dropdownConfig, definedStyles);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Creates a dropdown and stores it in the editor {@link module:ui/componentfactory~ComponentFactory}.
     *
     * @private
     * @param {module:image/imagestyle/imagestyleui~ImageStyleDropdownDefinition} dropdownConfig
     * @param {Array.<module:image/imagestyle~ImageStyleOptionDefinition>} definedStyles
     */

  }, {
    key: "_createDropdown",
    value: function _createDropdown(dropdownConfig, definedStyles) {
      var factory = this.editor.ui.componentFactory;
      factory.add(dropdownConfig.name, function (locale) {
        var defaultButton;
        var defaultItem = dropdownConfig.defaultItem,
            items = dropdownConfig.items,
            title = dropdownConfig.title;
        var buttonViews = items.filter(function (itemName) {
          return definedStyles.find(function (_ref) {
            var name = _ref.name;
            return getUIComponentName(name) === itemName;
          });
        }).map(function (buttonName) {
          var button = factory.create(buttonName);

          if (buttonName === defaultItem) {
            defaultButton = button;
          }

          return button;
        });

        if (items.length !== buttonViews.length) {
          utils.warnInvalidStyle({
            dropdown: dropdownConfig
          });
        }

        var dropdownView = createDropdown(locale, SplitButtonView);
        var splitButtonView = dropdownView.buttonView;
        addToolbarToDropdown(dropdownView, buttonViews);
        splitButtonView.set({
          label: getDropdownButtonTitle(title, defaultButton.label),
          class: null,
          tooltip: true
        });
        splitButtonView.bind('icon').toMany(buttonViews, 'isOn', function () {
          for (var _len = arguments.length, areOn = new Array(_len), _key = 0; _key < _len; _key++) {
            areOn[_key] = arguments[_key];
          }

          var index = areOn.findIndex(identity);
          return index < 0 ? defaultButton.icon : buttonViews[index].icon;
        });
        splitButtonView.bind('label').toMany(buttonViews, 'isOn', function () {
          for (var _len2 = arguments.length, areOn = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            areOn[_key2] = arguments[_key2];
          }

          var index = areOn.findIndex(identity);
          return getDropdownButtonTitle(title, index < 0 ? defaultButton.label : buttonViews[index].label);
        });
        splitButtonView.bind('isOn').toMany(buttonViews, 'isOn', function () {
          for (var _len3 = arguments.length, areOn = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            areOn[_key3] = arguments[_key3];
          }

          return areOn.some(identity);
        });
        splitButtonView.bind('class').toMany(buttonViews, 'isOn', function () {
          for (var _len4 = arguments.length, areOn = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            areOn[_key4] = arguments[_key4];
          }

          return areOn.some(identity) ? 'ck-splitbutton_flatten' : null;
        });
        splitButtonView.on('execute', function () {
          if (!buttonViews.some(function (_ref2) {
            var isOn = _ref2.isOn;
            return isOn;
          })) {
            defaultButton.fire('execute');
          } else {
            dropdownView.isOpen = !dropdownView.isOpen;
          }
        });
        dropdownView.bind('isEnabled').toMany(buttonViews, 'isEnabled', function () {
          for (var _len5 = arguments.length, areEnabled = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            areEnabled[_key5] = arguments[_key5];
          }

          return areEnabled.some(identity);
        });
        return dropdownView;
      });
    }
    /**
     * Creates a button and stores it in the editor {@link module:ui/componentfactory~ComponentFactory}.
     *
     * @private
     * @param {module:image/imagestyle~ImageStyleOptionDefinition} buttonConfig
     */

  }, {
    key: "_createButton",
    value: function _createButton(buttonConfig) {
      var _this = this;

      var buttonName = buttonConfig.name;
      this.editor.ui.componentFactory.add(getUIComponentName(buttonName), function (locale) {
        var command = _this.editor.commands.get('imageStyle');

        var view = new ButtonView(locale);
        view.set({
          label: buttonConfig.title,
          icon: buttonConfig.icon,
          tooltip: true,
          isToggleable: true
        });
        view.bind('isEnabled').to(command, 'isEnabled');
        view.bind('isOn').to(command, 'value', function (value) {
          return value === buttonName;
        });
        view.on('execute', _this._executeCommand.bind(_this, buttonName));
        return view;
      });
    }
  }, {
    key: "_executeCommand",
    value: function _executeCommand(name) {
      this.editor.execute('imageStyle', {
        value: name
      });
      this.editor.editing.view.focus();
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [ImageStyleEditing];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageStyleUI';
    }
  }]);

  return ImageStyleUI;
}(Plugin); // Returns the translated `title` from the passed styles array.
//
// @param {Array.<module:image/imagestyle~ImageStyleOptionDefinition|
// module:image/imagestyle/imagestyleui~ImageStyleDropdownDefinition>} styles
// @param {Object.<String,String>} titles
//
// @returns {Array.<module:image/imagestyle~ImageStyleOptionDefinition|module:image/imagestyle/imagestyleui~ImageStyleDropdownDefinition>}


export { ImageStyleUI as default };

function translateStyles(styles, titles) {
  var _iterator3 = _createForOfIteratorHelper(styles),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var style = _step3.value;

      // Localize the titles of the styles, if a title corresponds with
      // a localized default provided by the plugin.
      if (titles[style.title]) {
        style.title = titles[style.title];
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return styles;
} // Returns the image style component name with the "imageStyle:" prefix.
//
// @param {String} name
// @returns {String}


function getUIComponentName(name) {
  return "imageStyle:".concat(name);
} // Returns title for the splitbutton containing the dropdown title and default action item title.
//
// @param {String|undefined} dropdownTitle
// @param {String} buttonTitle
// @returns {String}


function getDropdownButtonTitle(dropdownTitle, buttonTitle) {
  return (dropdownTitle ? dropdownTitle + ': ' : '') + buttonTitle;
}
/**
 * # **The image style custom drop-down definition descriptor**
 *
 * This definition can be implemented in the {@link module:image/image~ImageConfig#toolbar image toolbar configuration}
 * to define a completely custom drop-down in the image toolbar.
 *
 *		ClassicEditor.create( editorElement, {
 *			image: { toolbar: [
 *	 			// One of the predefined drop-downs
 *	 			'imageStyle:wrapText',
 *				// Custom drop-down
 *				{
 *					name: 'imageStyle:customDropdown',
 *					title: Custom drop-down title,
 *					items: [ 'imageStyle:alignLeft', 'imageStyle:alignRight' ],
 *					defaultItem: 'imageStyle:alignLeft'
 *				}
 *			] }
 *		} );
 *
 * **Note:** At the moment it is possible to populate the custom drop-down with only the buttons registered by the `ImageStyle` plugin.
 *
 * The defined drop-down will be registered
 * as the {@link module:ui/dropdown/dropdownview~DropdownView}
 * with the {@link module:ui/dropdown/button/splitbuttonview~SplitButtonView} under the provided name in the
 * {@link module:ui/componentfactory~ComponentFactory}
 *
 * @property {String} name The unique name of the drop-down. It is recommended to precede it with the "imageStyle:" prefix
 * to avoid collision with the components' names registered by other plugins.
 *
 * @property {String} [title] The drop-down's title. It will be used as the split button label along with the title of the default item
 * in the following manner: "Custom drop-down title: Default item title".
 *
 * Setting `title` to one of
 * {@link module:image/imagestyle/imagestyleui~ImageStyleUI#localizedDefaultStylesTitles}
 * will automatically translate it to the language of the editor.
 *
 * @property {Array.<String>} items The list of the names of the buttons that will be placed in the drop-down's toolbar.
 * Each of the buttons has to be one of the {@link module:image/image~ImageConfig#styles default image style buttons}
 * or to be defined as the {@link module:image/imagestyle~ImageStyleOptionDefinition image styling option}.
 *
 * @property {String} defaultItem The name of one of the buttons from the items list,
 * which will be used as a default button for the drop-down's split button.
 *
 * @typedef {Object} module:image/imagestyle/imagestyleui~ImageStyleDropdownDefinition
 */